import React from 'react'

const Socials = () => {
    return (
        <div>
            <div className='mt-12 flex items-center gap-4 justify-center'>
                <div className='bg-blue-800 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                    <a href="/">
                        <i className="uil uil-facebook-f text-xl"></i>
                    </a>
                </div>
                <div className='bg-rose-500 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                    <a href="/">
                        <i className="uil uil-instagram text-xl"></i>
                    </a>
                </div>
                <div className='bg-blue-500 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                    <a href="/">
                        <i className="uil uil-twitter text-xl"></i>
                    </a>
                </div>
                <div className='bg-red-700 text-white rounded-full w-[40px] h-[40px] flex items-center justify-center cursor-pointer hover:translate-y-[-5px] duration-200 ease-in-out'>
                    <a href="/">
                        <i className="uil uil-youtube text-xl"></i>
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Socials